import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from '../../api/ApiSettings';
import { updateCustomerData } from "./customerSlice";

const initialState = {
  companies: [],
  isLoading: false,
  // isError: false,
  selectedRow: null,
  tablePage: 1,
  isRowSelected:false,
  searchValue: '',
  type:{
    id:0,
    displayName: '',
    customerType: '',
    description: '',
    value:''
  },
  selectedAddress: '',
  recipients: []
};

export const getCompanyByTaxId = createAsyncThunk('company/getCompanyByTaxId', async ({taxId}) => {
  const response = await fetch(`${API_URL}customer?taxId=${taxId}`);
  const data = await response.json(); 
  return data;
});
 
export const getCompanyByText = createAsyncThunk('company/getCompanyByText', async ({text}) => {
  const response = await fetch(`${API_URL}customer/byText?text=${text}`);
  const data = await response.json(); 
  return data;
});

export const getFromGus = createAsyncThunk('company/getFromGus', async ({taxId}) => {
  const response = await fetch(`${API_URL}customer/getFromGus?taxId=${taxId}`);
  const data = await response.json(); 
  return data;
});

export const getCustomerRecipients = createAsyncThunk('company/getCutomerRecipients', async({customerId})=>{
  const response = await fetch(`${API_URL}customer/getCustomerRecipients?customerId=${customerId}`);
  const data = await response.json();
  return data;
});

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => {
      const companyId = action.payload;
      state.selectedRow = state.companies.find(company => company.id === companyId);
      state.isRowSelected = true;
      state.selectedAddress = action.payload;
    },
    setTablePage: (state, action) => {
      state.tablePage = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setPersonalData: (state, action) => {
      state.personalData = action.payload;
    },
    // setComplaintType:(state, action)=>{
    //   state.type = action.payload;
    // },
    setCompanyType:(state, action)=>{
      state.type = action.payload;
    },
    setSelectedAddress: (state, action) =>{
      state.selectedAddress = action.payload;
    },
    setIsLoading: (state,action) =>{
      state.isLoading = action.payload;
    },
    resetCompanyData: () =>{
      return initialState;
    },
    setRecipients: (state, action) =>{
      state.recipients = action.payload;
    }
  },
  extraReducers: {
 
    [getCompanyByTaxId.pending]: (state) => {
      state.isLoading = true;
      state.isError = false;

    },
    [getCompanyByTaxId.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.companies = action.payload;
      // state.selectedRow = action.payload[0] || null;
    },
    // [getCompanyByTaxId.rejected]: (state) => {
    //   state.isError = true;
    //   state.isLoading = false;

    // },

    [getCompanyByText.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.companies = action.payload;
      // state.selectedRow = action.payload[0] || null;
    },

    [getFromGus.pending]: (state) => {
      state.isLoading = true;
      state.isError = false;

    },
    
    [getFromGus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.companies = action.payload;
      // state.selectedRow = action.payload[0] || null;
    },
    // [getFromGus.rejected]: (state) => {
    //   state.isError = true;
    //   state.isLoading = false;

    // },
    
    [getCustomerRecipients.fulfilled]: (state,action) =>{
      state.recipients = action.payload;
    }
  },
});


export const {
  setSelectedRow,
  setTablePage,
  setSearchValue,
  setPersonalData,
  setComplaintType,
  setCompanyType,
  setSelectedAddress,
  setIsLoading,
  resetCompanyData,
  setRecipients
} = companySlice.actions;
export const selectRecipients = (state) => state.company.recipients;
export default companySlice.reducer;
